import { Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';
import { AppConstants } from 'src/app/shared/entity/constants';
import { AddressDetails } from 'src/app/shared/models/address-details';
import { ItemDetailsResp } from 'src/app/shared/models/barcode';
import { ContainerSearchResponse } from 'src/app/shared/models/container-search';
import { ConnectionService } from 'src/app/shared/services/connection/connection.service';

@Injectable({
  providedIn: 'root'
})
export class LookupService {
 
  filteredOptions: any = [];
  val:any;
  environment: any;
  
  private readonly errorMessage = signal('');
  readonly notifyError = this.errorMessage.asReadonly();
  readonly notifyError$ = toObservable(this.notifyError);

  constructor(private readonly connectionService:ConnectionService) { }

  getBarcodeDetails(Barcode :any):Observable<any>{
    return this.connectionService.httpReq({
      reqType: AppConstants.GETREQUEST,
      endUrl: `items/barcode/${Barcode}`,
      directoryType: AppConstants.V4
    });
  }

  getItemsData(itemId:string):Observable<ItemDetailsResp>{
    return this.connectionService.httpReq({
      reqType: AppConstants.GETREQUEST,
      endUrl: `items/${itemId}`,
      directoryType: AppConstants.V4
    });
  }

  getEventsData(itemId:string):Observable<any[]> {
    return this.connectionService.httpReq({
      reqType: AppConstants.GETREQUEST,
      endUrl: `items/${itemId}/events`,
      directoryType: AppConstants.V4
    });
  }

  getCostCenter(businessLocationId:string): Observable<any[]> {
    return this.connectionService.httpReq({
      reqType: AppConstants.GETREQUEST,
      endUrl: `businesslocations/${businessLocationId}/costcenters`,
      directoryType: AppConstants.V4
    });
  }

  getItemsHistory(pn_item_id:string) {
    return this.connectionService.httpReq({
      reqType: AppConstants.GETREQUEST,
      endUrl: `itemHistory/${pn_item_id}`,
      directoryType: AppConstants.V4
    });
  }
  

  getPbmDetails(orderId:string):Observable<any[]>{
    return this.connectionService.httpReq({
      reqType: AppConstants.GETREQUEST,
      endUrl: `pbmOrder/${orderId}`,
      directoryType: AppConstants.V4
    });
  }
  getAddressDetails(addr:string):Observable<AddressDetails>{
    return this.connectionService.httpReq({
      reqType: AppConstants.GETREQUEST,
      endUrl: `addresses/${addr}`,
      directoryType: AppConstants.V4
    });
  }
  getRouteDetails(addr:string):Observable<any[]>{
    return this.connectionService.httpReq({
      reqType: AppConstants.GETREQUEST,
      endUrl: `addresses/${addr}/routes`,
      directoryType: AppConstants.V4
    });
  }
  getContainerDetails(barcode: string): Observable<ContainerSearchResponse> {
    return this.connectionService.httpReq({
      reqType: AppConstants.GETREQUEST,
      endUrl: `containers/${barcode}`,
      directoryType: AppConstants.DP
    });
  }

  getSearchResults(val:any){
    if (val != undefined && val !== '' && val.length >= 2) {
      const queryParams: any = {
        text: typeof (val) === 'object' ? val.properties.label : val
      };
      this.connectionService.httpReq({
        reqType: AppConstants.GETREQUEST,
        endUrl: '',
        directoryType: AppConstants.Address,
        data: queryParams
      }).subscribe({
        next: (resp: any) => {
          this.filteredOptions = resp.features;
        }, error: (error: any) => {
          this.filteredOptions = [];
        }
      })
  }
  
  }

  navigateToRouteDetails(routeId:string) {
    sessionStorage.setItem('route_Id', routeId);
    window.open('#/routeinfo','_blank');
  }

  showError(errorMessage: string) {
    this.errorMessage.set(errorMessage);
  }
}
  

